// extracted by mini-css-extract-plugin
export default {"parent-mode":"chapters_parent-mode__8JYVB","subtitle":"chapters_subtitle__iA1bq","disabledFields":"chapters_disabledFields__rjftx"};